/* Strategy RED – expanding header search controller */
(function () {
  'use strict';

  function initSearch(root) {
    if (root.__srSearch) return;
    root.__srSearch = true;

    var form = root.querySelector('[data-sr-search-form]');
    var input = root.querySelector('[data-sr-search-input]');
    var toggle = root.querySelector('[data-sr-search-toggle]');
    var results = root.querySelector('[data-sr-search-results]');
    var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var currency = root.getAttribute('data-currency') || '$';
    var timer = null, controller = null, lastQuery = '', active = -1;

    function isOpen() { return root.classList.contains('is-open'); }

    function open() {
      if (isOpen()) return;
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Search');
      input.removeAttribute('tabindex');
      // focus after the width transition starts so the caret lands inside the pill
      setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    }

    function close(restoreFocus) {
      if (!isOpen()) return;
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open search');
      input.setAttribute('tabindex', '-1');
      hideResults();
      if (restoreFocus) toggle.focus();
    }

    function hideResults() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }

    function money(v) {
      var n = Number(v);
      if (!isFinite(n)) return '';
      if (n > 1000 && String(v).indexOf('.') === -1) n = n / 100; // cents safety
      return currency + n.toFixed(2);
    }

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = (r.products || []).slice(0, 6);
      var collections = (r.collections || []).slice(0, 4);
      results.innerHTML = '';

      if (products.length) {
        results.appendChild(el('p', 'sr-search__label', 'Products'));
        var ul = el('ul', 'sr-search__list');
        ul.setAttribute('role', 'presentation');
        products.forEach(function (p) {
          var li = el('li'); li.setAttribute('role', 'presentation');
          var a = el('a', 'sr-search__item');
          a.href = p.url; a.setAttribute('role', 'option');
          var src = (p.featured_image && p.featured_image.url) || p.image;
          if (src) {
            var img = el('img', 'sr-search__thumb');
            img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
            img.alt = ''; img.loading = 'lazy'; img.width = 52; img.height = 52;
            a.appendChild(img);
          }
          var txt = el('span');
          txt.appendChild(el('span', 'sr-search__title', p.title));
          var price = el('span', 'sr-search__price', money(p.price));
          var cmp = Number(p.compare_at_price_max || p.compare_at_price_min || 0);
          if (cmp && cmp > Number(p.price)) price.appendChild(el('s', null, money(cmp)));
          txt.appendChild(price);
          a.appendChild(txt);
          li.appendChild(a); ul.appendChild(li);
        });
        results.appendChild(ul);
      }

      if (collections.length) {
        results.appendChild(el('p', 'sr-search__label', 'Collections'));
        var cl = el('ul', 'sr-search__list');
        cl.setAttribute('role', 'presentation');
        collections.forEach(function (c) {
          var li = el('li'); li.setAttribute('role', 'presentation');
          var a = el('a', 'sr-search__item sr-search__item--text', c.title);
          a.href = c.url; a.setAttribute('role', 'option');
          li.appendChild(a); cl.appendChild(li);
        });
        results.appendChild(cl);
      }

      if (!products.length && !collections.length) {
        results.appendChild(el('p', 'sr-search__empty', 'No results for “' + q + '”'));
      }

      var all = el('a', 'sr-search__all', 'View all results for “' + q + '”');
      all.href = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      all.setAttribute('role', 'option');
      results.appendChild(all);

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }

    function fetchSuggest(q) {
      if (controller && controller.abort) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=6' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) { if (q === lastQuery && isOpen()) render(q, data); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) { hideResults(); return; }
      timer = setTimeout(function () { fetchSuggest(q); }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.children.length) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    });

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (!isOpen()) { open(); return; }
      if (input.value.trim()) { form.submit(); return; }
      close(true);
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });

    // Keyboard: arrows move through suggestions, Esc closes
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!results.hidden) { hideResults(); input.focus(); }
        else close(true);
        e.stopPropagation();
        return;
      }
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !results.hidden) {
        var opts = results.querySelectorAll('[role="option"]');
        if (!opts.length) return;
        e.preventDefault();
        active = e.key === 'ArrowDown' ? (active + 1) % opts.length : (active <= 0 ? opts.length - 1 : active - 1);
        Array.prototype.forEach.call(opts, function (o, i) { o.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
        opts[active].focus();
      }
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (isOpen() && !root.contains(e.target)) close(false);
    });
    // Opening the mega menu drawer closes the search
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-sr-mega-toggle]')) close(false);
    }, true);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sr-search]'), initSearch);
  }

  if (document.querySelector('[data-sr-search]')) initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
